export default [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: '/appDown',
        name: 'appDown',
        component: () => import('@/views/application/index.vue')
    },
    {
        path: '/m_appDown',
        name: 'm_appDown',
        component: () => import('@/views/appdown/index.vue')
    },
    {
        path: '/home',
        // name: 'home',
        component: () => import(/* webpackChunkName: "home" */ '@/views/home'),
        children: [

            {
                path: 'workHall',
                name: 'workHall',
                component: () => import('@/views/personalCenter/workHall.vue')
            },
            {
                path: '',
                redirect: {
                    name: 'workHall'
                }
            },
            {
                path: 'personalCenter',
                name: 'personalCenter',
                component: () => import('@/views/personalCenter/personalCenter.vue'),
            },
            {
                path: 'operatoRegister',
                name: 'operatoRegister',
                component: () => import('@/views/personalCenter/operatoRegister.vue'),
            },
            {
                path: 'application',
                name: 'application',
                component: () => import('@/views/personalCenter/application.vue')
            },
            // 后台管理
            {
                path: 'adminRegister',
                name: 'adminRegister',
                component: () => import('@/views/admin/adminRegister')
            },
            {
                path: 'adminRegister/mallRegister',
                name: 'mallRegister',
                component: () => import('@/views/admin/adminRegister/mallRegister')
            },
            {
                path: 'adminRegister/OperatorRegistration',
                name: 'OperatorRegistration',
                component: () => import('@/views/admin/adminRegister/OperatorRegistration')
            },
            {
                path: 'adminRegister/schoolRegister',
                name: 'schoolRegister',
                component: () => import('@/views/admin/adminRegister/schoolRegister')
            },
            {
                path: 'adminRegister/openCardRegister',
                name: 'openCardRegister',
                component: () => import('@/views/admin/adminRegister/openCardRegister')
            },
            //后面新增的三个注册入口
            {
                path: 'adminRegister/enterpriseAdmins',
                name: 'enterpriseAdmins',
                component: () => import('@/views/admin/adminRegister/enterpriseAdmins')
            },
            {
                path: 'adminRegister/enterpriseBusiness',
                name: 'enterpriseBusiness',
                component: () => import('@/views/admin/adminRegister/enterpriseBusiness')
            },
            {
                path: 'adminRegister/enterpriseBusinessRegister',
                name: 'enterpriseBusinessRegister',
                component: () => import('@/views/admin/adminRegister/enterpriseBusinessRegister')
            },
            {
                path: 'adminRegister/personBusiness',
                name: 'personBusiness',
                component: () => import('@/views/admin/adminRegister/personBusiness')
            },
            // 新增的三个详情界面
            {
                path: 'adminRegister/enterpriseAdminsInfo',
                name: 'enterpriseAdminsInfo',
                component: () => import('@/views/admin/adminRegister/enterpriseAdminsInfo')
            },
            {
                path: 'adminRegister/enterpriseBusinessInfo',
                name: 'enterpriseBusinessInfo',
                component: () => import('@/views/admin/adminRegister/enterpriseBusinessInfo')
            },
            {
                path: 'adminRegister/OperatorInfo',
                name: 'OperatorInfo',
                component: () => import('@/views/admin/adminRegister/OperatorInfo')
            },

            {
                path: 'adminRegister/personBusinessInfo',
                name: 'personBusinessInfo',
                component: () => import('@/views/admin/adminRegister/personBusinessInfo')
            },


            {
                path: 'adminRegister/tenantInfo',
                name: 'tenantInfo',
                component: () => import('@/views/admin/adminRegister/tenantInfo')
            },
            {
                path: 'adminRegister/schoolInfo',
                name: 'schoolInfo',
                component: () => import('@/views/admin/adminRegister/schoolInfo')
            },
            {
                path: 'adminRegister/bankInfo',
                name: 'bankInfo',
                component: () => import('@/views/admin/adminRegister/bankInfo')
            },
        ]
    }
]
